import { z } from 'zod';

/**
 * The client surface a request came from: the native app or the web shell.
 * Shared by every dimension that records where something happened (sign-up
 * surface, consent capture surface) so the vocabulary is defined once and a
 * new surface widens all of them together, deliberately.
 */
export const CLIENT_SURFACE = ['mobile', 'web'] as const;
export const clientSurfaceSchema = z.enum(CLIENT_SURFACE);
export type ClientSurface = z.infer<typeof clientSurfaceSchema>;
